import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  modal: {
    minWidth: "90vw",
  },
  container: {
    width: "100%",
    fontFamily: "Manrope !important",
    flex: 1,
    flexDirection: "column",
    paddingBottom: "15px",
    alignItems: "center",
    justifyContent: "center",
  },
  subtitle: {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 600,
    color: "#465869",
  },
}));

export default styles;
